import { useState } from "react";
import { MyFormData, myAxios } from "../common/functions";
export default function FillIn({index, defaultValue, defaultChecked, className, handleNotes, handleHandled}){
    const [curentValue, setCurentValue] = useState(defaultValue ?? "");
    return(
        <>
        <div className = {className}>
            <label htmlFor = {"Notes " + index} className = "mb-0">Notes</label>
            <textarea
                id = {"Notes " + index}
                defaultValue = {curentValue}
                className = "mt-2 form-control"
                onBlur = {async e => {
                    const value = e.currentTarget.value;
                    setCurentValue(value);
                    handleNotes(value);
                }}
            />
        </div>
            <div className = "d-flex align-items-center mt-2">
                <input
                    id = {"completed " + index}
                    type = "checkbox"
                    className = "cssCheckBox"
                    defaultChecked = {defaultChecked === "true"}
                    onChange = {handleHandled}
                />
                <label htmlFor = {"completed " + index} className = "font-weight-bold ml-2 mb-0">Handled</label>
            </div>
        </>
    )
}